<template>
  <div id="swiper">
    <div class="swipe-parent">
      <div class="swiper-button-prev" slot="button-prev" :style="swiperButtonPrev" v-show="swipeList.length"></div>
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(page, pageIdx) in swipeList" :key="'swipe-page' + pageIdx">
          <!-- <template>
            <div v-for="(obj, index) in page" :key="'swipe' + index" v-bind:class="{select_swiper:true, selected:obj.id == selectedDcFdId}" @click="selected(obj)">
              <figure><img :src="obj.img"></figure>
              <figcaption class="plan_name">{{obj.name}}</figcaption>
            </div>
          </template> -->
          <div class="swipe_image"><img :src="page.img" @click="$emit('previewConstruct', page.imgB)"></div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next" slot="button-next" :style="swiperButtonNext" v-show="swipeList.length"></div>
    </div>
    <!-- <div class="swiper-pagination swiper-pagination-black" slot="pagination"></div> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as App from '../../../utils/App'

export default {
  name: 'addNewUserModal',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    swipeList: Array,
    swiperOptions: Object
    // horizontalMode: {
    //   type: Boolean,
    //   default: false
    // },
    // horizontalViewCnt: {
    //   type: Number,
    //   default: 10
    // },
    // selectedDcFdId: {
    //   type: Number,
    //   default: -1
    // }
  },
  data () {
    return {
      pageItemCount: 0,
      pageList: [],
      currentIndex: 0,
      swiperButtonPrev: {
        background: 'url(' + this.getImage('common/left.svg') + ') no-repeat center center / contain'
      },
      swiperButtonNext: {
        background: 'url(' + this.getImage('common/right.svg') + ') no-repeat center center / contain'
      }
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    selected: function (obj) {
      this.$emit('selected', obj)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
    // goToItemPage: function () {
    //   if (this.selectedDcFdId === -1) return
    //   let dcFdId = this.selectedDcFdId
    //   let listIdx = this.swipeList.findIndex(function (s) {
    //     return s.id === dcFdId
    //   })
    //   if (listIdx === -1) return
    //   let pageIdx = Math.floor(listIdx / this.horizontalViewCnt)
    //   this.mySwiper.slideTo(pageIdx, 1000, false)
    // }
  },
  watch: {
    // swipeList: function () {
    //   if (!this.horizontalMode) return
    //   this.pageList = []
    //   this.pageItemCount = this.horizontalViewCnt
    //   let maxPage = Math.floor((this.swipeList.length - 1) / this.pageItemCount) + 1
    //   for (let i = 0; i < maxPage; i++) {
    //     let startIdx = (i) * this.pageItemCount
    //     let endIdx = ((i + 1) * this.pageItemCount)
    //     let list = this.swipeList.filter(function (element, index) {
    //       return (index >= startIdx && index < endIdx)
    //     })
    //     this.pageList.push(list)
    //   }
    //   this.goToItemPage()
    // }
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.swipe-parent {
  display: flex;
  position: relative;
}

.swiper-slide {
  justify-content: baseline;
}
.swiper-button-prev {
  left: 0px;
  position: absolute;
  margin: auto;
  top: calc(50% - 1.8em);
  left: 0.2em;
  width: 1.4em;
}
.swiper-button-next {
  right: 0px;
  position: absolute;
  margin: auto;
  top: calc(50% - 1.8em);
  right: 0.2em;
  width: 1.4em;
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  position: absolute;
  margin: auto;
}
.swiper-slide {
  // width: calc(100% - 30px);
  width: auto;
}
.swipe_image {
  height: 100%;
  img {
    border-radius: 0.5rem;
  }
}
.swiper-pagination {
  position: initial;
  width: 100%;
}
.swiper-container {
  height: auto!important;
  // width: calc(100% - 80px);
  display: inline-block;
  width: 90%;
  margin: auto;
  padding: 0 5%;
}
.swiper-slide {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: calc(22.5% - .01px);
  height: 8em;
  // margin: 0.5rem;
  img {
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 960px) {/* 960px以上*/
  .swiper-slide {
    width: calc(22.5% - .01px);
  }
}

.select_swiper {
  border: 1px solid #dddddd;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  display: grid;
  width: 30%;
  min-width: 85px;
  margin: 5px;
  img {
    width: calc(100% - 2px);
    height: auto;
  }
  figcaption {
    padding: 5px;
    word-break: keep-all;
    word-wrap: break-word;
  }
  &.selected {
    border: 2px solid #e94919;
  }
  &:hover {
    box-shadow: 0 0px 2px 0px rgba(0, 0, 0, 0.2);
    color: #e94919;
    cursor: pointer;
  }
}

_:-ms-lang(x)::-ms-backdrop, .select_swiper {
  display: inline-table;
}
_:-ms-lang(x)::-ms-backdrop, .plan_name {
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/SwiperH.vue